var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-title-custom"},[_c('span',[_vm._v(_vm._s(_vm.getTranslatedText(_vm.value)))]),_vm._t(_vm.nameSlot)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }